import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { logout as logoutAction } from "@containers/Auth/store/actions";

/**
 * Logs the current user out immediately, with no confirmation step -- dispatches `logout.request()`
 * directly. For callers whose own UI already makes logout a deliberate, two-step action (open a menu,
 * then choose Logout), so a confirm step would be redundant -- currently the sidebar's avatar menu.
 */
export function useLogoutImmediate() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(logoutAction.request());
  }, [dispatch]);
}
